import { Typography } from '@casavo/base-ui'
import useTranslation from 'next-translate/useTranslation'
import Link from 'next/link'
import { useEffect } from 'react'

import Chevron from '@/components/Icon/Chevron'
import { Translated } from '@/components/Translated'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { handleClick, handleShow } from '@/utils/tracking/eventsHandlers'

import { bannerPanel } from './styles.css'

type Props = {
  nextUrl: string
  onCTAClick: VoidFunction
  totalProperties: number
}

export const NearbyBanner: React.FC<Props> = ({ nextUrl, onCTAClick, totalProperties }) => {
  const { t } = useTranslation()

  useEffect(() => {
    handleShow('NearPropertiesBanner', 'SeeBanner')
  }, [])

  return (
    <div className={bannerPanel} data-testid="nearby-properties-banner">
      <Typography variant="description">
        <Translated i18Key={t('listing-detail:NearPropertiesBanner_FirstStep_Description')} />
      </Typography>
      <Link passHref href={nextUrl}>
        <a
          className={sprinkles({
            alignItems: 'center',
            display: 'flex',
            fontWeight: 600,
          })}
          data-testid="reveal-index-button"
          onClick={() => {
            onCTAClick()
            handleClick('NearPropertiesBanner', 'FirstStep')
          }}
        >
          <Translated
            i18Key="listing-detail:NearPropertiesBanner_FirstStep_CTA"
            values={{ count: totalProperties - 1, n: totalProperties - 1 }}
          />
          <Chevron direction="right" />
        </a>
      </Link>
    </div>
  )
}
